define('plugin/client-login/controller/ClientLoginController',['require','lib/controller/BaseController','plugin/client-login/model/ClientRemindModel','plugin/client-login/view/ClientLoginRemindPasswordView','plugin/client-login/view/ClientLoginProfileView','plugin/client-login/view/ClientLoginStepView','lib/view/ModalRegion'],function (require) {

    var BaseController = require('lib/controller/BaseController');
    var ClientRemindModel = require('plugin/client-login/model/ClientRemindModel');
    var ClientLoginRemindPasswordView = require('plugin/client-login/view/ClientLoginRemindPasswordView');
    var ClientLoginProfileView = require('plugin/client-login/view/ClientLoginProfileView');
    var ClientLoginStepView = require('plugin/client-login/view/ClientLoginStepView');
    var ModalRegion = require('lib/view/ModalRegion');

    /**
     * Client login Controller
     *
     * @class ClientLoginController
     */
    return BaseController.extend({

        _clientModel: null,
        _signInModel: null,
        _remindModel: null,
        _handler: null,
        _backUrl: null,

        initialize: function () {
            this._clientModel = this.getOption('clientModel');
            this._signInModel = this.getOption('signInModel');
            this._remindModel = new ClientRemindModel();

            this._handler = this.getOption('handler');

            BaseController.prototype.initialize.call(this);
        },

        remind: function () {
            this._remind(this.getMainLayout().getContentRegion());
        },

        remindPopup: function () {
            this._remind(new ModalRegion(), true);
        },

        _remind: function (region, isModal) {
            if (this._clientModel.get('is_logged_in')) {
                this._redirect('');
                return;
            }

            var view = new ClientLoginRemindPasswordView({
                model: this._remindModel,
                isModal: isModal
            });

            this.listenTo(view, 'remind', this.performRemind);

            region.show(view);
        },

        performRemind: function (data) {
            this._remindModel.set(data.view.getDataToRemind());
            this._remindModel.save(null, {
                'success': function () {
                    data.view.setSuccessMessage(Locale.getNonEscape('remind_email_sent'));
                    data.view.render();
                }
            });
        },

        editProfilePopup: function () {
            this._profile(new ModalRegion(), true, true);
        },

        viewProfilePopup: function () {
            this._profile(new ModalRegion(), false, true);
        },

        profile: function (edit) {
            this._profile(this.getMainLayout().getContentRegion(), edit);
        },

        _profile: function (region, edit, isModal) {
            if (!this._clientModel.get('is_logged_in')) {
                var back = '';
                if (edit) {
                    back = '/back/' + encodeURIComponent('client/profile/1');
                }

                this._redirect('client/sign-in' + back);
                return;
            }

            var view = new ClientLoginProfileView({
                model: this._clientModel,
                edit: edit,
                isModal: isModal
            });

            this.listenTo(view, 'update', this.performUpdateProfile);
            this.listenTo(view, 'signOut', this.signOut);

            region.show(view);
        },

        performUpdateProfile: function (data) {
            this._clientModel.set(data.view.getProfileData());
            this._clientModel.save(null, {
                'success': function () {
                    data.view.setSuccessMessage(Locale.getNonEscape('profile_updated_success'));
                    data.view.render();
                }
            });
        },

        signOut: function () {
            this._handler.performSignOut();
            this._redirect('');
        },

        signIn: function (back, message) {
            this._signIn(this.getMainLayout().getContentRegion(), back, message);
        },

        _signIn: function (region, back, message) {
            this._backUrl = back;

            var view = new ClientLoginStepView({
                clientModel: this._clientModel,
                signInModel: this._signInModel,
                termsModel: this._handler.getTermsController().getModel(),
                message: message
            });

            this.listenTo(view, 'signIn', _.bind(function (data) {
                this._handler.performSignIn(data.view.getDataToSignIn());
            }, this));

            this.listenTo(view, 'signUp', _.bind(function (data) {
                this._handler.performSignUp(data.view.getDataToSignUp());
            }, this));

            this.listenTo(view, 'dom:refresh', _.bind(function () {
                view.showTermsAndConditions(this._handler.getTermsController().getView());
            }, this));

            this.listenTo(view, 'clientLogged', this.performRedirectBack);

            region.show(view);
        },

        performRedirectBack: function () {
            if (!this._backUrl) {
                this._backUrl = 'client/profile';
            }
            this._redirect(this._backUrl);
        }

    });

});
